import { fetch } from 'http-common';

import { SizeScale, SizeScaleApplyResult, SizeScaleDiff } from 'types/api/sizeScales.type';

class SizeScalesDataService {
  private http = fetch();

  private ep = '/v1/admin/size-scales';

  private static fileForm(file: File): FormData {
    const formData = new FormData();
    formData.append('file', file);
    return formData;
  }

  public async getAll() {
    return this.http.get<SizeScale[]>(this.ep);
  }

  // Compares the file with the table; writes nothing
  public async previewImport(file: File) {
    return this.http.post<SizeScaleDiff>(
      `${this.ep}/import/preview`,
      SizeScalesDataService.fileForm(file),
      // let the browser set multipart/form-data with its boundary
      { headers: { 'Content-type': undefined } as any }
    );
  }

  // Sends the same file again: the backend recomputes the changes before writing them
  public async applyImport(file: File) {
    return this.http.post<SizeScaleApplyResult>(
      `${this.ep}/import/apply`,
      SizeScalesDataService.fileForm(file),
      { headers: { 'Content-type': undefined } as any }
    );
  }
}

export const sizeScalesDataService = new SizeScalesDataService();
